import { isMobile } from 'react-device-detect';

import SpiderSpriteSheet from '../assets/cave/spider-row.png';
import BatsSpriteSheet from '../assets/cave/bats-row.png';
import WolfSpriteSheet from '../assets/cave/wolf-row.png';
import SpiderInfo from '../assets/cave/backend-info.png';
import BatsInfo from '../assets/cave/devops-info.png';
import WolfInfo from '../assets/cave/frontend-info.png';

import { spiderConfigs, batsConfigs, wolfConfigs } from './spriteConfigs';

const animalsConfigs = [
  {
    id: 1,
    name: 'spider',
    className: 'spider-container',
    spritePath: SpiderSpriteSheet,
    spriteConfigs: spiderConfigs,
    info: SpiderInfo,
    style: {
      right: '70%',
      top: '40%',
      zIndex: '1',
    },
  },
  {
    id: 2,
    name: 'bats',
    className: 'bats-container',
    spritePath: BatsSpriteSheet,
    spriteConfigs: batsConfigs,
    info: BatsInfo,
    style: {
      right: '64%',
      top: '17%',
      zIndex: '1',
    },
  },
  {
    id: 3,
    name: 'wolf',
    className: 'wolf-container',
    spritePath: WolfSpriteSheet,
    spriteConfigs: wolfConfigs,
    info: WolfInfo,
    style: {
      bottom: '40%',
      left: `${isMobile ? '0' : '20%'}`,
      zIndex: '1',
    },
  },
  {
    id: 4,
    name: 'dragon',
    className: 'dragon-container',
  },
];

export default animalsConfigs;
